import { useClassNames } from "../../hooks/useClassNames";

export const Tabs = ({tabs, onSelectedTab}) => {
  const { classNames } = useClassNames();
  
  return (
    <div>
      <div className="sm:hidden">
        <label htmlFor="tabs" className="sr-only">
          Select a tab
        </label>
        {/* Use an "onChange" listener to redirect the user to the selected tab URL. */}
        <select
          id="tabs"
          name="tabs"
          className="block w-full rounded-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500"
          defaultValue={tabs.find((tab) => tab.current).name}
        >
          {tabs.map((tab) => (
            <option key={tab.name}>{tab.name}</option>
          ))}
        </select>
      </div>
      <div className="hidden sm:block">
        <div className="border-b border-gray-200 dark:border-gray-700">
          <nav className="-mb-px flex" aria-label="Tabs">
            {tabs.map((tab) => (
              <a
                key={tab.name}
                href={tab.href}
                onClick={() => onSelectedTab(tab.tab)}
                className={classNames(
                  tab.current
                    ? 'border-brand-blue text-gray-900 dark:text-gray-100'
                    : 'border-transparent text-gray-700 hover:border-gray-300 hover:text-gray-800 dark:text-gray-300 dark:hover:border-gray-600 dark:hover:text-gray-200',
                  'w-full max-w- border-b-2 py-4 px-1 text-center text-sm font-medium'
                )}
                aria-current={tab.current ? 'page' : undefined}
              >
                {tab.name}
              </a>
            ))}
          </nav>
        </div>
      </div>
    </div>
  )
}